export const ACTIVATE_JOIN_LINE_TOOL = '@edit-tools/ACTIVATE_JOIN_LINE_TOOL';
export const ACTIVATE_INTERSECTION_SPLIT_LINE_TOOL = '@edit-tools/ACTIVATE_INTERSECTION_SPLIT_LINE_TOOL';
export const DEACTIVATE_TOOL = '@edit-tools/DEACTIVATE_TOOL';
export const PREPARE_LOAD_FEATURES = '@edit-tools/PREPARE_LOAD_FEATURES';
export const PREPARE_SAVE_FEATURES = '@edit-tools/PREPARE_SAVE_FEATURES';
export const UPDATE_JOIN_LINE_TOOL = '@edit-tools/UPDATE_JOIN_LINE_TOOL';
export const UPDATE_SELECT_FEATURE_TOOL = '@edit-tools/UPDATE_SELECT_FEATURE_TOOL';
export const UPDATE_LOADED_FEATURES = '@edit-tools/UPDATE_LOADED_FEATURES';
export var SELECTED_SEGMENTS;
(function (SELECTED_SEGMENTS) {
    SELECTED_SEGMENTS["ALL"] = "ALL";
    SELECTED_SEGMENTS["OUTER"] = "OUTER";
    SELECTED_SEGMENTS["ONE"] = "ONE";
    SELECTED_SEGMENTS["NONE"] = "NONE";
})(SELECTED_SEGMENTS || (SELECTED_SEGMENTS = {}));
export var INTERSECTION_TYPE;
(function (INTERSECTION_TYPE) {
    INTERSECTION_TYPE["EXTEND"] = "EXTEND";
    INTERSECTION_TYPE["CROP"] = "CROP";
    INTERSECTION_TYPE["REPLACE"] = "REPLACE";
    INTERSECTION_TYPE["NONE"] = "NONE";
})(INTERSECTION_TYPE || (INTERSECTION_TYPE = {}));
//# sourceMappingURL=constants.js.map